import { z } from 'zod';

export const changeInvestorCreditSplitPostRequestSchema = z.object({ company: z.string(), value: z.string() });
